import axiosInstance from "../../helpers/axios";
import {
  catchHandler,
  dispatchError,
  dispatchLoading,
  elseHandler,
} from "../../helpers/dispatch";
import { responseDataFormate } from "../../helpers/bycrypt";

export const GetCountryListAPI =
  () => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getCountry", true);
    axiosInstance
      .get(`/country`, {
        withCredentials: true,
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          dispatch({
            type: "GET_COUNTRY_DATA",
            payload: result?.data || [],
          });
        } else {
          elseHandler(dispatch, "getCountry", result);
        }
        dispatchLoading(dispatch, "getCountry", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getCountry")(err);
      });
  };

export const GetPrefixListAPI =
  (country_id: string, zone_id?: string | null, search: string = "", page: number = 1, limit: number = 150) =>
  async (dispatch: (action: any) => void) => {
    if (!country_id) {
      dispatch({ type: "CLEAR_PREFIX_DATA" });
      return;
    }
    dispatchLoading(dispatch, "getPrefix", true);
    return axiosInstance
      .get(`/delivery-postcode-prefix`, {
        params: { country_id, zone_id: zone_id || null, search, page, limit },
        withCredentials: true,
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          dispatch({
            type: "GET_PREFIX_DATA",
            payload: {
              list: result?.data?.list || [],
              count: result?.data?.count || 0,
              page: page
            }
          });
        } else {
          elseHandler(dispatch, "getPrefix", result);
        }
        dispatchLoading(dispatch, "getPrefix", false);
        return result;
      })
      .catch((err) => {
        catchHandler(dispatch, "getPrefix")(err);
        throw err;
      });
  };
